<template>
  <a-form-item :label="field.name">
    <a-select
      :mode="mode"
      placeholder="Vui lòng chọn"
      @change="onChange"
      :value="value"
      style="width: 100%;"
    >
      <a-select-option v-for="i in choiceValues" :key="i" :value="i">
        {{ i }}
      </a-select-option>
    </a-select>
    <!-- <a-input
      v-decorator="[
        field.code,
        { rules: [{ required: true, message: 'Please input your note!' }] },
      ]"
    /> -->
  </a-form-item>
</template>
<script>
export default {
  props: {
    field: {
      type: Object,
      required: true,
    },
    value: String,
  },
  methods: {
    onChange(eventData) {
      if (typeof eventData === "string") {
        this.$emit("input", eventData);
      } else {
        this.$emit("input", JSON.stringify(eventData));
      }
    },
  },
  computed: {
    choiceValues() {
      if (
        this.field?.options?.choices &&
        typeof this.field.options.choices === "string"
      ) {
        return JSON.parse(this.field.options.choices);
      } else {
        return [];
      }
    },
    mode() {
      if (this.field?.options?.canChoiceMultiple) {
        return "multiple";
      } else {
        return "default";
      }
    },
  },
  created() {},
};
</script>
